export default {
  back: '返回座位配置',
  backShort: '返回',
  title: '座位编排',
  stepArrange: '座位编排',
  stepLayout: '场地布置',
  stepSeating: '座位安排',
  editorModes: '编排模式',
  progress: '已分配 {assigned} / {total} 个座位',
  unsaved: '有未保存调整',
  save: '保存',
  lastSaved: '自动保存 {time}',
  notSaved: '尚未保存',
  rosterTitle: '参会人员名单',
  rosterProgress: '已分配 {assigned} / {total} 人',
  newPending: '发现新成员待分配 {count} 人',
  addMembers: '添加名单',
  addRoster: '导入名单',
  importRegistration: '导入报名人员',
  registrationImportSuccess: '报名人员已同步：新增 {added} 位，移除 {removed} 位',
  registrationImportEmpty: '报名名单没有变化',
  saveBeforeRoster: '请先保存当前座位调整，再导入名单',
  saveBeforePrint: '当前有未保存的座位调整，请先保存后再打印。',
  saveLayoutBeforeSwitchConfirm: '场地布置有未保存的修改，是否保存后切换到座位安排？',
  saveAndSwitch: '保存并切换',
  sortLabel: '排序方式',
  sortShort: '排序',
  sortForm: '表单顺序',
  sortName: '姓名',
  sortDept: '部门',
  sortUnassigned: '默认顺序（待分配优先）',
  sortNameAsc: '姓名拼音 A-Z',
  sortNameDesc: '姓名拼音 Z-A',
  sortOrganization: '单位 / 姓名',
  sortSeat: '座位顺序',
  autoFill: '自动补位',
  autoFillHint: '保留已安排的座位，只把尚未分配的人员按所选排序补入空位（锁定座位不参与）',
  lockMode: '位置锁定 · VIP座位',
  lockModeOn: '位置锁定 · 开启中',
  finishVipLock: '完成 VIP座位设置',
  finishVipLockHint: '保存 VIP 座位设置并退出锁定模式',
  lockModeHint: '点击空座位锁定为 VIP 专属，再次点击取消',
  lockSeatAssigned: '该座位已有人员，无法锁定为 VIP 专属',
  lockBannerTitle: '位置锁定模式已开启',
  lockBannerSub: '点击空座位锁定为 VIP 专属，再次点击已锁定座位可取消；锁定座位不参与自动补位。',
  lockedSeatCount: '已锁定 {count} 个座位',
  exitLock: '退出锁定',
  vipLockHint: '点击空座位设置 / 取消 VIP 锁定。锁定位置仅接收 VIP 名单，完成后关闭此模式。',
  searchRoster: '搜索姓名 / 单位 / 职务',
  noOrganization: '暂无单位',
  unassigned: '待分配座位',
  seatPosition: '{unit} · 第 {no} 位',
  noRosterMatch: '没有匹配的人员',
  emptyRoster: '暂无参会人员',
  canvasTip: '从左侧拖拽成员分配；长按已分配座位可拖拽换座，拖到已分配座位则交换',
  properties: '属性面板',
  available: '可放置',
  seatDetails: '座位详情',
  unit: '所在桌台',
  row: '第几排',
  column: '第几列',
  rowValue: '第 {row} 排',
  columnValue: '第 {column} 列',
  seatNo: '座位编号',
  seatNumberValue: '第 {no} 号位',
  phone: '手机号',
  status: '状态',
  lockedTag: '已锁定',
  assigned: '已分配',
  empty: '空位',
  clearAssignment: '清除此座位分配',
  emptySeatHint: '从左侧拖拽成员',
  emptySeatHintSecond: '到此座位完成分配',
  selectSeat: '点击座位或桌台查看详细信息',
  seatOccupied: '该座位已经分配人员',
  saveSuccess: '座位分配已保存',
  sources: {
    registration: '报名人员',
    imported: '导入人员'
  }
}
